import { createSelector } from 'reselect';
import { IMessagesState, IMessage } from './types';

export const selectMessagesLoadedState = (state: IMessagesState) => state.messagesLoaded;
export const selectMessageLoadedState = (state: IMessagesState) => state.messageLoaded;
export const selectMessageTypesLoadedState = (state: IMessagesState) => state.messageTypesLoaded;

export const selectMessages = (state: IMessagesState) => state.messages;
export const selectMessageTypes = (state: IMessagesState) => state.messageTypes;
export const selectSelectedMessage = (state: IMessagesState) => state.selectedMessage;

export const selectSyncError = (state: IMessagesState) => state.error;
export const selectSyncState = (state: IMessagesState) => state.syncing;
export const selectMessageSaved = (state: IMessagesState) => state.messageSaved;

export const selectIndexedMessages = createSelector(selectMessages, (messages) =>
  messages.reduce((indexed: { [key: string]: IMessage }, message: IMessage) => {
    if (message.id) {
      indexed[message.id] = message;
    }
    return indexed;
  }, {})
);
export const selectMessage = createSelector(
  [selectIndexedMessages, (_: IMessagesState, id: string) => id],
  (indexedMessages, id) => indexedMessages[id]
);
